export const state = {
	loggedUser: null,
	sessionLoaded: false,
	now: Date.now(),
	nowLazy: Date.now()
};